export const EDI_WITH_PURCHASER_ORDER_COMMENT = ['SELLSY', 'STANDARD'];
